import { render, staticRenderFns } from "./DriverSettlementComponent.vue?vue&type=template&id=c0485dea&scoped=true&"
import script from "./DriverSettlementComponent.vue?vue&type=script&lang=js&"
export * from "./DriverSettlementComponent.vue?vue&type=script&lang=js&"
import style0 from "./DriverSettlementComponent.vue?vue&type=style&index=0&id=c0485dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0485dea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
